import { v4 as uuidv4 } from 'uuid'
import { t } from 'ttag'

export const getColumns = () => [
  { header: t`department`, accessorKey: 'name', alignLeft: true },
  { header: t`members`, accessorKey: 'users_count' },
  { header: t`number of positions`, accessorKey: 'projects_count' },
  { header: t`created`, accessorKey: 'created_at' },
  { header: '', id: uuidv4() },
]
